// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"
import HelloController from "./hello_controller"
application.register("hello", HelloController)
// @ts-ignore
import NotificationController from "./notification_controller"
application.register("notification", NotificationController)
// @ts-ignore
import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)
// @ts-ignore
import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)
